import React, { useState, useEffect } from 'react';

import NuxeoClient from '../../clients/NuxeoClient';
import Dropdown from '../ui/Dropdown';

import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import InputLabel from '@material-ui/core/InputLabel';

import { useI18n } from '../../I18nProvider';

export default function AssetFileName(props) {

    const appText = useI18n();
    const [fetchedData, setFethchedData] = useState([]);
    const [timeID, setTimeID] = useState([]);

    useEffect(() => {
        if (props.fetchedProperty.length > 0) {
            _loadAssetFileNames();
        };
    }, [props.fetchedProperty]);

    async function _loadAssetFileNames(input = '') {

        let licenseeList = '';
        let propsList = '';

        for (let code of props.fetchedLicensees) {
            licenseeList += ' OR admin:licenseeCodeGroup = "lic:' + code.properties['licensee:licenseeCode'] + '"';
        }

        for (let prop of props.fetchedProperty) {
            const propId = prop.id || '';
            const prefixedId = propId.startsWith('default:') ? propId : `default:${propId}`;
            const unprefixedId = propId.replace(/^default:/, '');

            // Include both prefixed and unprefixed variants so assets tagged either way are returned
            propsList += ` OR public:property = "${prefixedId}"`;
            if (prefixedId !== unprefixedId) {
                propsList += ` OR public:property = "${unprefixedId}"`;
            }
        }

        let exclusivity = ' AND (admin:wbcpRegionGroup IS NULL) AND (admin:licenseeCodeGroup IS NULL' + licenseeList + ')';
        let allProperties = ' AND (public:property IS NULL' + propsList + ')';
        let styleGuideQuery = 'public:theme != "Style Guide Package" and ' +
            'public:theme != "00. Printable Styleguide" and ' +
            'public:theme != "00. Printable Style Guides" and ' +
            'public:theme != "Brand Assurance Guidelines" and ' +
            'admin:publishYn = 1' + exclusivity + allProperties;
        await NuxeoClient
            .instance()
            .fetchAssetFileNames(styleGuideQuery, input)
            .then((response) => {
                setFethchedData(response.entries);
            })
            .catch(error => console.log(error))
    };

    const loadAssets = input => {
        setTimeID(timeID => [...timeID, setTimeout(() => _loadAssetFileNames(input), 2000)]);
        timeID.forEach(time => window.clearTimeout(time));
    };  

    const handleChange = (assets) => {
        if (assets === null) {

            props.handleChange('originalAssetsUID', []);
            props.handleChange('originalAssetsParentRef', []);
            props.handleChange('assetFileName', []);
            props.handleChange('assetFileID', null);
    
        } else if (assets.length > props.value.length) {

            props.handleChange('assetFileID', assets[assets.length - 1].uid);

            let values = [...props.value];
            values.push(assets[assets.length - 1].label);
            props.handleChange('assetFileName', values);

            let ids = [...props.id];
            ids.push(assets[assets.length - 1].uid);
            props.handleChange('originalAssetsUID', ids);

            let refs = [...props.parentRef];
            refs.push(assets[assets.length - 1].parentRef);
            props.handleChange('originalAssetsParentRef', refs);

        } else {

            const assetTitles = assets.map(asset => asset = asset.label);
            const deletedAsset = props.value.filter(value => !assetTitles.includes(value));

            let deletedIndex;
            let values = [...props.value];
            props.value.forEach((value, index) => {
                if (value === deletedAsset[0]) {
                    deletedIndex = index;
                    values.splice(index, 1);
                }
            })
            props.handleChange('assetFileName', values);

            let ids = [...props.id];
            ids.splice(deletedIndex, 1);
            props.handleChange('originalAssetsUID', ids);

            let refs = [...props.parentRef];
            refs.splice(deletedIndex, 1);
            props.handleChange('originalAssetsParentRef', refs);
        }

    };

    return (
        // <Tooltip arrow title="Please, include the file name of any assets used or referenced in this submission">
            <Tooltip arrow title={appText.T132}>
            <Grid item={true} xs={12}>
                <div id="assetFileName">
                    <InputLabel className="field-label field-dropdown"
                        required={props.isRequired}>
                        {/* Asset File Name */}
                        {appText.T84}
                    </InputLabel>
                    <Dropdown
                        data={fetchedData}
                        value={props.value}
                        handleChange={handleChange}
                        loadData={loadAssets}
                        type={"assetFileName"}
                    />
                    {/* <small><i>You may begin typing in the field above to search for the STAR LABS Asset you are referencing for this submission. If you are not referencing a STAR LABS asset, you may search for and select "Licensee Reference Artwork."</i></small> */}
                    <small><i>{appText.T85}</i></small>
                </div>
            </Grid>
        </Tooltip>
    );
};